// Modal component that handles Yes/No related functionality

import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
} from "@mui/material";

type YesNoModalProps = {
    message: string;
    isOpen: boolean;
    onClose: () => void;
    onYes: () => void;
};

export const YesNoModal = ({ message, isOpen, onClose, onYes }: YesNoModalProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{message}</DialogTitle>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    No
                </Button>
                <Button variant="contained" onClick={onYes} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};